import { render, staticRenderFns } from "./MyLotsEmptyFarmer.vue?vue&type=template&id=364f3f6f"
import script from "./MyLotsEmptyFarmer.vue?vue&type=script&lang=js"
export * from "./MyLotsEmptyFarmer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports